import LightTextPanel from "./LightTextPanel";

export default LightTextPanel;